import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import './AppFooter.css';

class AppFooter extends Component {


	render() {
        return (
			<footer className="AppFooter container">
				<div className="AppFooter-links"><Link to="/impressum/">Impressum & Datenschutz</Link></div>
				<div className="AppFooter-info">Alle Angaben ohne Gewähr</div>
			</footer>
        );
    }
}

export default AppFooter;



// WEBPACK FOOTER //
// ./src/components/AppFooter.js